module.exports = __webpack_public_path__ + "static/img/Visualization2.5c4acf60.png";